import { useEffect, useRef, useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { IntroComponent } from "./_components/CommonComponent";
import MainComponent from "./_components/MainComponent";
import ScrollToTop from "./_components/ScrollToTop";
function App() {
  const asmrMainRef = useRef();
  const warEleRef = useRef();
  const marrEleRef = useRef();

  return (
    <>
    <IntroComponent />
    <BrowserRouter basename={window.location.pathname }>    
    <ScrollToTop asmrMainRef={ asmrMainRef } warEleRef={ warEleRef } marrEleRef={ marrEleRef } />
      <Routes>
        <Route path="/" element={<MainComponent asmrMainRef={ asmrMainRef } warEleRef={ warEleRef } marrEleRef={ marrEleRef } />} />
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;